import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom-v5-compat';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import { MessageDescriptorPropType } from '../../../../../prop-types/intl';

export const NavigationButton = ({ navigationTarget, onNavigationClicked, buttonText }) => {
  const navigate = useNavigate();
  const onClick = useCallback(() => {
    navigate(navigationTarget);
    onNavigationClicked();
  }, [navigate, navigationTarget, onNavigationClicked]);

  return (
    <Button onClick={onClick} theme='tertiary'>
      <FormattedMessage {...buttonText} />
    </Button>
  );
};

NavigationButton.propTypes = {
  onNavigationClicked: PropTypes.func.isRequired,
  navigationTarget: PropTypes.string.isRequired,
  buttonText: MessageDescriptorPropType.isRequired,
};
